<template>
  <BCIconBanner
    background-color="#771d31"
    icon-color="#cbb762"
    text-color="#fff"
    fluid
  >
    <div class="container">
      <div class="row">
        <div class="col">
          <h3 class="mb-16">
            {{ title || $label('banners.premiumBanner.title') }}
          </h3>
          <p class="mb-24">
            {{ text || $label('banners.premiumBanner.text') }}
          </p>
          <BaseButton
            :class="[{ loading: isRequestingUpgrade }]"
            data-testid="upgrade-btn"
            variant="call-to-action"
            class="mb-24"
            @click="upgradeToPremium"
          >
            {{ btnText || $label('banners.premiumBanner.btnText') }}
          </BaseButton>
          <p class="text-small mb-0 fst-italic">
            {{ caption || $label('banners.premiumBanner.caption') }}
          </p>
        </div>
      </div>
    </div>
  </BCIconBanner>
</template>

<script>
import BCIconBanner from '~/components/banners/BCIconBanner'
import SubscriptionMixin from '~/mixins/subscription'

export default {
  components: {
    BCIconBanner,
  },
  mixins: [SubscriptionMixin],
  props: {
    title: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    btnText: {
      type: String,
      default: '',
    },
    caption: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
.infinity-sign-banner {
  margin: 0;
}

:deep(.infinity-sign-banner__row) {
  padding: 32px 40px !important;
}
</style>
